import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothTextInput from '../components/RothTextInput.js';
import ReactModal from 'react-modal';
import RothSelect from '../components/RothSelect.js';

export default class ForgotPage extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalOK = this.handleModalOK.bind(this);
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }
  handleModalOK() {
    this.setState({ showModal: false });
    this.props.forgotPassword('');
  }
  isValid() {
    return (
      !this.props.forgotPasswordSent &&
      this.props.validate('user', 'username') === '' &&
      this.props.validate('user', 'name') === '' &&
      this.props.validate('user', 'phone') === '' &&
      this.props.validate('user', 'company') === ''
    );
  }
  style = {};

  render = () => (
    <div className="content">
      <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
        {'← ' + this.props.text('other', 'back')}
      </RothButton>
      <div className="inner">
        <div>
          <h1>{this.props.text('forgot', 'h1')}</h1>
          <p>{this.props.text('forgot', 'desc')}</p>
          <div style={{ padding: '20px 40px 0px 40px' }}>
            <RothTextInput
              param="username"
              value={this.props.user.username}
              placeholder={'' /*this.props.text("forgot", "placeholder")*/}
              fn={this.props.changeUserParam}
              disabled={this.props.forgotPasswordSent}
            >
              {this.props.text('forgot', 'email')}
            </RothTextInput>
            <RothTextInput
              param="name"
              value={this.props.user.name}
              placeholder={'' /*this.props.text("forgot", "placeholder")*/}
              fn={this.props.changeUserParam}
              disabled={this.props.forgotPasswordSent}
            >
              {this.props.text('forgot', 'name')}
            </RothTextInput>
            <RothTextInput
              param="phone"
              value={this.props.user.phone}
              placeholder={'' /*this.props.text("forgot", "placeholder")*/}
              fn={this.props.changeUserParam}
              disabled={this.props.forgotPasswordSent}
            >
              {this.props.text('forgot', 'phone')}
            </RothTextInput>
            <RothSelect
              param="departmentID"
              value={this.props.user.departmentID}
              fn={this.props.changeUserParam}
              options={this.props.options.departments.reduce((ret, key) => {
                ret[key] = this.props.text('other', 'department_' + key);
                return ret;
              }, {})}
              disabled={this.props.forgotPasswordSent}
            >
              {this.props.text('forgot', 'country')}
            </RothSelect>
            <RothTextInput
              param="company"
              value={this.props.user.company}
              placeholder={'' /*this.props.text("newUser", "placeholder")*/}
              fn={this.props.changeUserParam}
              disabled={this.props.forgotPasswordSent}
            >
              {this.props.text('forgot', 'company')}
            </RothTextInput>
          </div>
        </div>

        <ReactModal
          isOpen={this.state.showModal}
          contentLabel=""
          style={{
            content: {
              position: 'absolute',
              top: '30%',
              width: 'calc(100% - 80px)',
              marginLeft: 'auto',
              marginRight: 'auto',
              height: '300px',
              border: '0px solid white',
              backgroundColor: this.props.constants.colorRed,
              borderRadius: '22px',
              padding: '40px 10px',
              maxWidth: '500px',
            },
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>
              {this.props.text('forgot', 'sendPopup')}
            </div>
            <div style={{ textAlign: 'center' }}>
              <RothButton type="halfWhite" fn={this.handleModalOK}>
                {this.props.text('forgot', 'ok')}
              </RothButton>
            </div>
          </div>
        </ReactModal>
      </div>
      <RothButton disabled={!this.isValid()} type="wide" fn={this.handleOpenModal}>
        {this.props.text('forgot', 'send')}
      </RothButton>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/ForgotPage.js
 **/